
import state from './contactsState.js'
import * as mutations from './contactsMutations.js'
import * as actions from './contactsActions.js'
import * as getters from './contactsGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}